import React from "react";

const STATUS_STYLE = {
  present: "text-[#00ff90] bg-[#00ff90]/10 border-[#00ff90]/20",
  absent:  "text-red-400 bg-red-500/10 border-red-500/20",
  leave:   "text-yellow-400 bg-yellow-500/10 border-yellow-500/20",
  wfh:     "text-blue-400 bg-blue-500/10 border-blue-500/20",
  late:    "text-orange-400 bg-orange-500/10 border-orange-500/20",
};

const btnBase = "text-xs px-3 py-1.5 rounded-lg border border-[#00ff90]/20 bg-[#00ff90]/5 text-[#00ff90]/70 hover:bg-[#00ff90]/15 hover:text-[#00ff90] transition-colors";

export default function DailyTeamGrid({ loading, rows, onRowClick }) {
  if (loading) {
    return (
      <div className="space-y-2">
        {Array.from({ length: 6 }).map((_, i) => (
          <div key={i} className="h-12 rounded-lg bg-white/5 animate-pulse" />
        ))}
      </div>
    );
  }

  if (!rows?.length) {
    return <p className="text-white/30 text-sm py-4 text-center italic">No records for this date.</p>;
  }

  return (
    <div className="overflow-x-auto">
      <table className="w-full text-sm">
        <thead>
          <tr className="border-b border-white/5">
            {["Member", "Status", "In", "Out", "Hours", "Late (min)", "OT (min)", "Flags", ""].map(h => (
              <th key={h} className="px-3 py-3 text-left text-xs text-[#00ff90]/40 uppercase tracking-wider font-medium whitespace-nowrap">{h}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map(r => {
            const statusKey = String(r.status || "").toLowerCase();
            const statusStyle = STATUS_STYLE[statusKey] || "text-white/30 bg-white/5 border-white/10";
            return (
              <tr key={r.id} className="border-b border-white/5 hover:bg-white/3 transition-colors">
                <td className="px-3 py-3">
                  <button onClick={() => onRowClick?.(r)} className="text-left hover:text-[#00ff90] transition-colors">
                    <p className="text-white font-medium">{r.name}</p>
                    <p className="text-white/30 text-xs">{r.role}</p>
                  </button>
                </td>
                <td className="px-3 py-3">
                  <span className={`text-xs px-2 py-0.5 rounded-full border capitalize ${statusStyle}`}>
                    {r.status || "—"}
                  </span>
                </td>
                <td className="px-3 py-3 text-white/50 font-mono text-xs">{r.in || "—"}</td>
                <td className="px-3 py-3 text-white/50 font-mono text-xs">{r.out || "—"}</td>
                <td className="px-3 py-3 text-white/60 text-xs">{r.hours || "—"}</td>
                <td className="px-3 py-3 text-orange-400/70 text-xs">{r.late || "—"}</td>
                <td className="px-3 py-3 text-blue-400/70 text-xs">{r.ot || "—"}</td>
                <td className="px-3 py-3 text-xs text-white/30">{(r.flags || []).join(", ") || "—"}</td>
                <td className="px-3 py-3">
                  <button onClick={() => onRowClick?.(r)} className={btnBase}>View</button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}